import { decisionSchema } from "features/common/schemas";
import { denormalize } from "normalizr";

const DEFAULT_DATA = Object.assign([], { loading: true, loaded: false });
const getApprovalLevelsFlags = (state, id) => state.document.decision.approvalLevels[id];
const getApprovalsHistoryFlags = (state, id) => state.document.decision.approvalsHistory[id];
const getDecisionState = (state, id) => denormalize(id, decisionSchema, state.entities);

export const getApprovalLevels = (state, key) => {
  const flags = getApprovalLevelsFlags(state, key);
  if (!flags || !flags.loaded || flags.loading) return DEFAULT_DATA;

  const approvalLevels = getDecisionState(state, key).approvalLevels;
  return {approvalLevels: approvalLevels, loaded: flags.loaded, loading: flags.loading };
};

export const getApprovalsHistory = (state, key) => {
  const flags = getApprovalsHistoryFlags(state, key);
  if (!flags || !flags.loaded || flags.loading) return DEFAULT_DATA;

  const approvalsHistory = getDecisionState(state, key).approvalsHistory;
  return {approvalsHistory: approvalsHistory, loaded: flags.loaded, loading: flags.loading};
};

export const getDecisionTypes = state => {
  return state.dictionaries.decisionTypes.isLoaded ? state.dictionaries.decisionTypes.items : [];
};

export const getUserProfile = state => {
  return state.oidc.user && state.oidc.user.profile;
};

export const getSelectedOffer = state => {
  const folderOfferIds = state.currentFolder?.financedOffers?.ids;
    let minOfferId = null;
    if (folderOfferIds && folderOfferIds.length > 0)
      minOfferId = Math.min(...folderOfferIds);
    if (minOfferId)
      return state.entities.financedOffers?.[minOfferId]
  return null;
}